import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { ConfirmationService, ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { camps } from '../../../../../../../models/models.generated';
import { DayVariantManagementApiService } from '../../../../../../../services/api/day-variant-management-api.service';
import { CampsDetailsFormBuilder } from '../../../../camp-details-form-builder';
import { CampsDetailsFormStateService } from '../../../../camp-details-form-state-service';

@Component({
    selector: 'app-day-variants-list',
    templateUrl: './day-variants-list.component.html',
    styleUrls: ['./day-variants-list.component.scss'],
    standalone: false
})
export class DayVariantsListComponent implements OnInit {
    @Input() public form: UntypedFormGroup;

    constructor(
        public state: CampsDetailsFormStateService,
        private formBuilder: CampsDetailsFormBuilder,
        private confirm: ConfirmationService,
        private translate: TranslateService,
        private api: DayVariantManagementApiService,
        private alert: BayclubsAlertService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit(): void {}

    public isEdited(form: UntypedFormGroup) {
        return this.state.isEdited(form);
    }

    public add() {
        var array = this.form.controls['items'] as UntypedFormArray;

        var days = this.form.controls['allDays'].value;

        console.log(days);
        var newItem = this.formBuilder.buildDayVariantItem(
            <camps.DaysVariantDefinitionDetails>{
                name: '',
                sessionDays: [],
                isVisibleToMembers: false
            },
            this.form.get('sessionId').value,
            days
        );

        array.insert(0, newItem);

        this.state.markAsEdited(newItem);
    }

    public get isAnyItemEdited() {
        return this.state.isAnyItemEdited();
    }

    public onCancel(form: UntypedFormGroup) {
        if (!form.controls['id'].value) {
            this.removeFromArray(form);
        }

        this.state.finishEdit(form, false);
    }

    public edit(form: UntypedFormGroup) {
        this.state.markAsEdited(form);
    }

    public onRemoved(form: UntypedFormGroup) {
        this.confirm
            .show(
                this.translate.instant('CampDetails.RemoveConfirmationTitle'),
                this.translate.instant('CampDetails.RemoveConfirmation')
            )
            .subscribe(result => {
                if (result === true) {
                    // this.removeFromArray(form);
                    // this.change.detectChanges();
                    var request = <camps.SessionDayVariantRemoveRequest>{ dayVariantId: form.get('id').value };

                    this.api.remove(request).subscribe(x => {
                        if (x.isSuccess) {
                            this.removeFromArray(form);
                            this.alert.showOperationSuccess();
                            this.state.sessionChanged.emit(form.get('sessionId').value);
                        } else {
                            this.errorTranslate.translateValidationNotifications(x.validationNotification);
                            this.alert.showError(x.validationNotification.errors[0].message);
                        }
                    });
                }
            });
    }

    private removeFromArray(form: UntypedFormGroup) {
        var arr = this.form.controls['items'] as UntypedFormArray;
        var index = arr.controls.findIndex(f => f == form);
        arr.removeAt(index);
    }
}
